// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    addToChainAfter,
    addToEndOfChain,
    addToStartOfChain,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import { CreateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";
import xLoadingOverlay from "@steiner/App/Handlers/XNG/LoadingOverlay";
import { Draft } from "immer";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess<QuoteModel> & HasOnError<string> & { poNumber: string; shipTo?: string },
    CreateQuoteApiParameter,
    QuoteModel
>;

// XNG-Changes: match classic customizations

export const XngUpdateQuoteCart: HandlerType = async props => {
    const { value: cart } = getCurrentCartState(props.getState());
    if (!cart) {
        throw new Error("The cart is not loaded. Try reloading the page.");
    }
    if (cart.lineCount > 0) {
        const cartClone = cloneDeep(cart) as Draft<typeof cart>;
        cartClone.poNumber = props.parameter.poNumber;
        if (props.parameter.shipTo !== cart.shipToId) {
            cartClone.shipToId = props.parameter.shipTo;
        }
        await updateCart({ cart: cartClone });
    }
};

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", id: "create_request_quote" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "clear", id: "create_request_quote" }));
};

addToChainAfter(chain, PopulateApiParameter, XngUpdateQuoteCart);
addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
